import makePick from './make_pick/index';
import modalSettings from './settings/modal';
import fsmMakePick from './fsm/make_pick';

const modalPlayer = function($container) {
  const container = $container || $('@body');
  const $modalOpen = container.find($('@modalPlayer'));

  makePick(container);

  const afterOpen = (id) => {
    const $addThisPlayer = $('@addThisPlayer');
    const $playerTarget = $(`input[value="${id}"]`);

    if (fsmMakePick.is('completed') || $playerTarget.is(':checked')) {
      $addThisPlayer.remove();
    }

    $addThisPlayer.on('click', () => {
      $playerTarget.prop('checked', true);
      $.modal.close();
      $playerTarget.parent($('form')).trigger('change');
    });
  };

  $.each($modalOpen, function(e) {
    const $this = $(this);

    $this.on('click', function(e) {
      e.preventDefault();
      const $this = $(this);
      const $thisHref = $this.attr('href');
      const playerId = $this.data('player');
      $this.blur();

      // container.on($.modal.AFTER_CLOSE, (event, modal) => {
      //   makePick(container);
      // });

      // container.on($.modal.OPEN, (event, modal) => {
      // });

      $.ajax({
        url: $thisHref,
        type: 'GET',
        success(data) {
          $(data).appendTo('body').modal(modalSettings);
          const $addThisPlayer = $('@modal').find('@addThidPlayer');
          afterOpen(playerId);
        },
        error(data) {
          console.log('woops!');
        },
      });
    });
  });
};

export default modalPlayer;

